var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.modelWrap},[_c('div',{class:_vm.$style.modelBox},[_c('edit-header',{class:_vm.$style.header,on:{"save":_vm.handleSave}}),_c('edit-main',{ref:"refMain",class:_vm.$style.main})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }